import get from 'lodash/get';
import { SHIPMENT_PRIORITY_RANK } from '../../utils/constants';
import {
  FETCH_SHIPMENTS_DETAILS,
  FETCH_SHIPMENTS_DETAILS_FAILURE,
  FETCH_SHIPMENTS_DETAILS_SUCCESS,
} from './types';

const priorityRank = (p) => {
  if (p == null || p === '') return 99;
  const key = String(p).toLowerCase();
  return SHIPMENT_PRIORITY_RANK[key] !== undefined ? SHIPMENT_PRIORITY_RANK[key] : 99;
};

const initialState = {
  isShipmentsLoading: false,
};

const ShipmentDashBoardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHIPMENTS_DETAILS: {
      return {
        ...state,
        isShipmentsLoading: true,
      };
    }

    case FETCH_SHIPMENTS_DETAILS_SUCCESS: {
      const resData = get(action, 'response', []);
      resData.rows.sort((a, b) => {
        const pr = priorityRank(a.priority) - priorityRank(b.priority);
        if (pr !== 0) return pr;
        return (b.id || 0) - (a.id || 0);
      });
      resData.rows.map((item, i) => {
        item.sno = i + 1;
      });
      return {
        ...state,
        shipmentListData: resData.rows,
        shipmentsCount: resData.count,
        isShipmentsLoading: false,
      };
    }

    case FETCH_SHIPMENTS_DETAILS_FAILURE: {
      return {
        ...state,
        isShipmentsLoading: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default ShipmentDashBoardReducer;
